import React from "react";

import LandingPage from "./courtyard/entrance/LandingPage.js";

import LandPageCover from "./courtyard/entrance/LandPageCover.js";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Routes,
  Switch,
  Navigate,
} from "react-router-dom";

import { useAuth } from "./context/Use-Context.js";

import { AuthContext } from "./context/App-Context.js";

import Altar from "./temple/Altar/Altar.js";

import ZeusdbStatue from "./statues/zeusdb/ZeusdbStatue.js";

import Porch from "./courtyard/door/Porch.js";
import TempleGridChapelCourtYard from "./courtyard/templegrid/entrance/TempleGridChapelCourtYard.js";
import TempleGridStatues from "./courtyard/templegrid/entrance/TempleGridStatues.js";
import EntranceVerification from "./courtyard/door/EntranceVerification.js";
import TgAltar from "./temple/templegridroom/TgAltar.js";
import TempleGridChapel from "./courtyard/templegrid/entrance/TempleGridChapel.js";
import TgProfile from "./temple/templegridroom/TgProfile.js";
import TempleGridPhotoVault from "./temple/templegridroom/TempleGridPhotoVault.js";
import LoginBackSplash from "./TempleGridAdmin/Login/LoginBackSplash.js";
import TempleGridTickets from "./TempleGridAdmin/DashBoard/TempleGridTickets.js";
import TempleGridContinueSubscription from "./temple/templegridroom/TempleGridPaymentPanel/TempleGridContinueSubscription.js";
import TempleGridPhotoVaultBackPlash from "./temple/templegridroom/UserPhotoVault/TempleGridPhotoVaultBackSplash.js";
import TempleGridPhotoVaultBackSplash from "./temple/templegridroom/UserPhotoVault/TempleGridPhotoVaultBackSplash.js";
import PhotoVaultPhotos from "./temple/templegridroom/UserPhotoVault/PhotoVaultItems/PhotoVaultPhotos.js";
import UserFeedPagetgrid from "./temple/templegridroom/UserOculus/UserFeedPagetgrid.js";
import Subscribe from "./courtyard/door/Subscribe.js";
import AngelTempleGridStatue from "./courtyard/templegrid/entrance/AngelTempleGridStatue.js";
import SubscriptionStatus from "./temple/templegridroom/SubscriptionStatus.js";
import TgridAmindLoginBackSplash from "./TempleGridAdmin/Login/TgridAmindLoginBackSplash.js";
import PhotoVaultSingleVaultItem from "./temple/templegridroom/UserPhotoVault/PhotoVaultItems/PhotoVaultSingleVaultItem.js";
import PhotoVaultPhotosItems from "./temple/templegridroom/UserPhotoVault/PhotoVaultItems/PhotoVaultPhotosItems.js";
import TempleGridFlexDashboard from "./temple/templegridroom/Flex/TempleGridFlexDashboard.js";
import TestingOcancerImages from "./TestingOcancerImages/TestingOcancerImages.js";
import TestingOcancerImagesShiftFromFossila2 from "./TestingOcancerImages/TestingOcancerImagesShiftFromFossila2.js";
import TempleGridDocsHome from "./TempleGridLibrary/LibraryHomeLobby/TempleGridDocsHome.js";
import DoorFrameDetector from "./TestingOcancerImages/DoorFrameDetector.js";
import DoorUploadDetector from "./TestingOcancerImages/DoorUploadDetector.js";
import TensorDrawingExporter from "./TestingOcancerImages/TensorDrawingExporter.js";
import DoorVerticalDebugger from "./TestingOcancerImages/DoorVerticalDebugger.js";
import SnapDetector from "./TestingOcancerImages/SnapDetector.js";
import TreeWireframeScanner from "./TestingOcancerImages/treeDetector/TreeDetector.js";
import TreeVerticalScanner from "./TestingOcancerImages/treeDetector/TreeVerticleScanner.js";
import CourtyardCurrentConsole from "./CourtyardCurrent/CourtyardCurrentConsole.js";

const App = () => {
  const {
    login,
    logout,
    loginVar,

    TGRIDAMIND_login,
    TGRIDAMIND_logout,
    TGRIDAMIND_loginVar,
  } = useAuth();
  let theRoutes;
  // <Routes>
  //   <Route path="/" element={<LandingPage />} />
  //   {/* <Route path="/house-login" element={<HouseEntrance />} /> */}
  //   <Route path="/house123" element={<Altar />} />
  //   <Route path="/documentation" element={<ZeusdbStatue />} />
  //   <Route path="/TempleGrid" element={<TempleGridChapelCourtYard />} />
  //   <Route
  //     path="/TempleGrid/zeusfromthethrone"
  //     element={<TempleGridStatues />}
  //   />

  //   <Route path="/TempleGrid/zeusfromthethrone" element={" Profiles Page "} />

  //   <Route path="/TempleGrid/zeusfromthethrone" element={" Profiles Page "} />

  //   <Route path="/login" element={<Porch />} />
  //   <Route path="/signup" element={<EntranceVerification />} />
  // </Routes>

  //////

  if (loginVar) {
    theRoutes = (
      <Routes>
        <Route
          path="/"
          element={<Navigate to={`/TempleGrid/${loginVar}`} replace />}
        />
        {/* <Route path="/" element={<LandingPage />} /> */}
        {/* <Route path="/house-login" element={<HouseEntrance />} /> */}
        {/* <Route path="/house123" element={<Altar />} /> */}
        <Route path="/documentation" element={<ZeusdbStatue />} />
        {/* <Route path="/TempleGrid" element={<TempleGridChapelCourtYard />} /> */}
        <Route path="/TempleGrid/info" element={<TempleGridDocsHome />} />
        <Route
          path="/TempleGrid/:UsernameUserID"
          element={<AngelTempleGridStatue />}
        />
        <Route
          path="/TempleGrid/doorframedetector"
          element={<DoorFrameDetector />}
        />
        {/* <Route
          path="/TempleGrid/dooruploaddetector"
          element={<DoorUploadDetector />}
        /> */}
        <Route
          path="/TempleGrid/dooruploaddetector"
          element={<SnapDetector />}
        />
        <Route
          path="/TempleGrid/treedetect"
          element={<TreeVerticalScanner />}
        />
        <Route path="/TempleGrid/flex" element={<TempleGridFlexDashboard />} />
        <Route path="/TestingOcancerImgz" element={<TestingOcancerImages />} />

        {/* <Route
          path="/TempleGrid/zeusfromthethrone"
          element={" Profiles Page "}
        /> */}

        {/* <Route
          path="/TempleGrid/zeusfromthethrone"
          element={" Profiles Page "}
        /> */}
        <Route path="/TempleGrid/Profile" element={<TgProfile />} />

        {/* <Route path="/login" element={<Porch />} />
        <Route path="/signup" element={<EntranceVerification />} /> */}
        {/* <Route path="/TempleGridHome123" element={<TgAltar />} />
        <Route
          path="/TempleGrid/photoVault"
          element={<TempleGridPhotoVaultBackSplash />}
        />
        <Route path="/TempleGridHome" element={<TempleGridChapel />} />
        <Route path="/Ocancerz" element={<UserFeedPagetgrid />} />
        <Route path="/tgridvault" element={<TempleGridPhotoVault />} />
        <Route
          path="/TempleGrid/photoVault/vaultNumber"
          element={<PhotoVaultPhotos />}
        /> */}
        <Route
          path="/TempleGrid/photoVault/:UsernameUserID"
          element={<PhotoVaultPhotos />}
        />

        <Route
          path="/TempleGrid/photovault/album"
          element={<PhotoVaultPhotosItems />}
        />
        {/* <Route path="/AdminLogin-heywhatsup" element={<LoginBackSplash />} />
        <Route
          path="/AdminDashBoard-heywhatsup"
          element={<TempleGridTickets />}
        /> */}
        <Route path="/TempleGrid/subscribe" element={<Subscribe />} />

        {/* if no subscription direct to here  */}
        <Route path="/Subscribe" element={<TempleGridContinueSubscription />} />
        <Route
          path="templeGrid/Subscription"
          element={<SubscriptionStatus />}
        />
        {/* <Route path="/TestingOcancerImgz" element={<TestingOcancerImages />} /> */}
        <Route
          path="/TestingOcancerImgza2"
          element={<TestingOcancerImagesShiftFromFossila2 />}
        />
        <Route path="/ocancerz" element={<CourtyardCurrentConsole />} />

        {/* after sign up , direct to here for subscription*/}
        <Route
          path="*"
          element={<Navigate to={`/TempleGrid/${loginVar}`} replace />}
        />
      </Routes>
    );
  } else if (TGRIDAMIND_loginVar) {
    theRoutes = (
      <Routes>
        <Route
          path="/admin-go/Start-TempleGrid"
          element={<TempleGridTickets />}
        />
        ;
      </Routes>
    );
  } else {
    theRoutes = (
      <Routes>
        {/* <Route path="/" element={<LandingPage />} /> */}
        {/* <Route path="/house-login" element={<HouseEntrance />} /> */}
        {/* <Route path="/AdminLogin-heywhatsup" element={<LoginBackSplash />} /> */}
        {/* <Route path="/documentation" element={<ZeusdbStatue />} /> */}
        <Route path="/TempleGrid" element={<TempleGridChapelCourtYard />} />
        <Route
          path="/TempleGrid/Tgrid-amindLogin-GO"
          element={<TgridAmindLoginBackSplash />}
        />
        {/* <Route path="/TempleGrid/info" element={<TempleGridDocsHome />} /> */}
        <Route path="/login" element={<Porch />} />
        <Route path="/signup" element={<EntranceVerification />} />
        <Route path="*" element={<TempleGridChapelCourtYard />} />
      </Routes>
    );
  }

  /////

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: !!loginVar,

        loginVar: loginVar,
        login: login,
        logout: logout,
        ////// admin token ,
        ///// login , info
        //TGRIDAMIND_isLoggedIn: !!TGRIDAMIND_loginVar,

        TGRIDAMIND_loginVar: TGRIDAMIND_loginVar,
        TGRIDAMIND_login: TGRIDAMIND_login,
        TGRIDAMIND_logout: TGRIDAMIND_logout,
      }}
    >
      <Router>
        <div>{theRoutes}</div>
      </Router>
    </AuthContext.Provider>
  );
};

export default App;
